import {
  HTTP_REJECTAPPROVE_FETCHING,
  HTTP_REJECTAPPROVE_SUCCESS,
  HTTP_REJECTAPPROVE_FAILED,
} from "././../../Constants";

const initialState = {
  result: null,
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_REJECTAPPROVE_FETCHING:
      return { ...state, result: null, isLoading: true, isError: false };
    case HTTP_REJECTAPPROVE_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_REJECTAPPROVE_FAILED:
      return { ...state, result: null, isLoading: false, isError: true };
    default:
      return state;
  }
};
